import * as React from 'react';

import Map, {Layer, Marker, Popup, Source} from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
// eslint-disable-next-line
import mapboxgl from '!mapbox-gl';
import {Box, CircularProgress, Typography} from "@mui/material";
import * as turf from "@turf/turf";
import {PieChart} from "react-minimal-pie-chart";
import {Pin} from "../../../App";
import {correctName, getColor, getIconById} from "../../../Utils";
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;
const MAPBOX_TOKEN = 'pk.eyJ1IjoiYmxhbmdlNDgiLCJhIjoiY2xkMWhrcjBzMDB1aDNzbGVsdGR5cGU1aSJ9.xcs1ihAFqlazzqNrXNiobQ';


export default function MapIris({
                                    address, geom, visible,
                                    resultsGeomByBvsSynthese
                                }) {
    const [centroid, setCentroid] = React.useState(null);
    const [bbox, setBBbox] = React.useState(null);

    const [loading, setLoading] = React.useState(true);

    const [listOfIcons, setListOfIcons] = React.useState(null);
    const data = []
    React.useEffect(() => {
        if (geom) {
            let bboxShape = {
                "type": "FeatureCollection",
                "features": []
            };

            bboxShape.features.push({
                type: "Feature",
                geometry: JSON.parse(geom.geom)
            });

            let bbox = turf.bbox(bboxShape);
            let centroid = turf.centroid(bboxShape);
            setCentroid(centroid.geometry.coordinates);
            setBBbox([[bbox[0] - 0.001, bbox[1] - 0.001], [bbox[2] + 0.001, bbox[3] + 0.001]]);

        }
        let listOfIcons = {}
        Object.keys(address.bvs).forEach((address,id) => {
            let splitted = address.split("_")
            const correctedId = splitted[0].padStart(5, '0') + "_" + splitted[1].padStart(4, '0');
            listOfIcons[correctedId] = id
        })
        setListOfIcons(listOfIcons)

    }, [geom]);

    React.useEffect(() => {
        if (centroid && bbox) {
            setLoading(false);
        }
    }, [centroid, bbox])


    if (visible) {
        if (loading) {
            return (<Box sx={{
                width: '100%',
                height: 610,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                <CircularProgress/>
            </Box>)
        } else {

            return (<Box sx={{width: '100%', height: 610, display: "flex", flexDirection: "row", mb: 2}}>
                <Map
                    style={{
                        width: "60%",
                        height: 600,
                        borderRadius: 25
                    }}
                    initialViewState={{
                        longitude: centroid[0],
                        latitude: centroid[1],
                        bounds: bbox

                    }}
                    mapStyle="mapbox://styles/mapbox/streets-v9"
                    mapboxAccessToken={MAPBOX_TOKEN}
                    interactive={true}
                    preserveDrawingBuffer={true}
                    attributionControl={false}
                >
                    <Source
                        type="geojson"
                        data={JSON.parse(geom.geom)}>
                        <Layer
                            type={'line'}
                            paint={{
                                'line-width': 2,
                                'line-color': '#000000'
                            }}
                        />
                    </Source>
                    {Object.keys(address.bvs).map((id, key) => {
                        let bvs = address.bvs[id];
                        let color = getColor(address.bvs[id].color)
                        let splitted = id.split("_")
                        const correctedId = splitted[0].padStart(5, '0') + "_" + splitted[1].padStart(4, '0');

                        return bvs.bans.map((ban, index) => {
                            return (<Marker
                                key={`marker-${index}`}
                                longitude={Number(ban.latitude)}
                                latitude={Number(ban.longitude)}

                            >
                                {getIconById(listOfIcons[correctedId],color,5)}
                            </Marker>)
                        })

                    })}
                </Map>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: "40%",
                    height: 600,
                    overflow: "auto",
                    ml: 2
                }}>
                    {Object.keys(address.bvs).map((id, key) => {
                        let color = getColor(address.bvs[id].color)
                        let splitted = id.split("_")
                        const correctedId = splitted[0].padStart(5, '0') + "_" + splitted[1].padStart(4, '0');

                        let name = id
                        if (resultsGeomByBvsSynthese[correctedId]) {
                            name = resultsGeomByBvsSynthese[correctedId].name
                        }

                        return (<Box key={id} sx={{width: "100%",}}>
                            <Box sx={{display: "flex", flexDirection: 'row',}}>
                                <Box sx={{width: 20, height: 20,mr:2}}>
                                    {getIconById(listOfIcons[correctedId],color)}
                                </Box>
                                <Typography>{name}</Typography>
                            </Box>
                            <Box sx={{display: "flex", flexDirection: "column"}}>
                                {address.bvs[id].bans.map((ban, index2) => {
                                    return (<Typography
                                        key={index2}
                                        sx={{ml: 5}}>
                                        {correctName(ban.libelleBan)}
                                    </Typography>)
                                })}
                            </Box>
                        </Box>)
                    })}
                </Box>
            </Box>);
        }
    }
}
